var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"path_div"},[_c('TitleBackground'),_c('Paths')],1)}
var staticRenderFns = []

export { render, staticRenderFns }